import ua from '../util/ua';
import convertToArray from './convertToArray';

class PeriodSelectorSeparate {
  init() {
    this.doc = document;
    this.dialogAttr = 'data-change-period-dialog';
    this.dialog = convertToArray(this.doc.querySelectorAll(`[${this.dialogAttr}]`));
    this.dialogLen = this.dialog.length;
    this.dialogActiveClass = 'is_active';
    this.selectItemAttr = 'data-change-period-item';
    this.customAttr = 'data-change-period-custom';
    this.customActiveClass = 'is_active';
    this.backdrop = this.doc.getElementById('backdrop');
    this.backdropActiveClass = 'is_active_transparent';
    this.uaPc = !ua.Mobile && !ua.Tablet;
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.showCustom = this.showCustom.bind(this);
    this.hideCustom = this.hideCustom.bind(this);
    this.addPullDown = this.addPullDown.bind(this);
    this.removePullDown = this.removePullDown.bind(this);
    this.pullDown = this.pullDown.bind(this);
    this.pullDownFocus = this.pullDownFocus.bind(this);
    this.escape = this.escape.bind(this);
  }
  start() {
    this.btnAttr = 'data-change-period-btn';
    this.btn = convertToArray(document.querySelectorAll(`[${this.btnAttr}]`));
    this.btnLen = this.btn.length;
    if (!this.btnLen) return;
    this.init();
    for (let bi = 0; bi < this.btnLen; bi += 1) {
      this.btn[bi].addEventListener('click', this.show);
      if (this.uaPc) {
        this.btn[bi].addEventListener('focus', this.addPullDown);
        this.btn[bi].addEventListener('blur', this.removePullDown);
      }
    }
  }
  show(e) {
    this.activeBtn = e.currentTarget;
    this.targetAttrVal = this.activeBtn.getAttribute(this.btnAttr);
    this.getOpenedDialog();
    this.getOpenedDialogItem();
    this.backdrop.classList.add(this.backdropActiveClass);
    this.backdrop.addEventListener('click', this.hide);
    this.doc.addEventListener('keydown', this.escape);
    this.openCustomBtn.addEventListener('click', this.showCustom);
    this.activeBtn.removeEventListener('click', this.show);
    this.activeBtn.addEventListener('click', this.hide);
  }
  getOpenedDialog() {
    for (let di = 0; di < this.dialogLen; di += 1) {
      const target = this.dialog[di];
      if (target.getAttribute(this.dialogAttr) === this.targetAttrVal) {
        this.openedDialog = target;
        this.openedDialog.classList.add(this.dialogActiveClass);
      }
    }
  }
  getOpenedDialogItem() {
    this.selectItem = convertToArray(this.doc.querySelectorAll(`[${this.selectItemAttr}=${this.targetAttrVal}]`));
    this.selectItemLen = this.selectItem.length;
    this.custom = this.doc.querySelector(`[${this.customAttr}=${this.targetAttrVal}]`);
    this.openCustomBtn = this.selectItem[this.selectItemLen - 1];
  }
  hide() {
    this.openedDialog.classList.remove(this.dialogActiveClass);
    this.backdrop.classList.remove(this.backdropActiveClass);
    this.backdrop.removeEventListener('click', this.hide);
    for (let bi = 0; bi < this.btnLen; bi += 1) {
      this.btn[bi].addEventListener('click', this.show);
      this.btn[bi].removeEventListener('click', this.hide);
    }
    this.doc.removeEventListener('keydown', this.escape);
    this.openCustomBtn.removeEventListener('click', this.showCustom);
    this.doc.removeEventListener('keydown', this.pullDownFocus);
    this.resetItem();
  }
  resetItem() {
    this.openedDialog = null;
    this.selectItem = null;
    this.selectItemLen = null;
    this.custom = null;
    this.openCustomBtn = null;
  }
  showCustom() {
    this.custom.classList.add(this.customActiveClass);
    for (let i = 0; i < this.selectItemLen - 1; i += 1) {
      this.selectItem[i].addEventListener('click', this.hideCustom);
    }
  }
  hideCustom() {
    this.custom.classList.remove(this.customActiveClass);
    for (let i = 0; i < this.selectItemLen - 1; i += 1) {
      this.selectItem[i].removeEventListener('click', this.hideCustom);
    }
  }
  addPullDown(e) {
    this.focusBtn = e.currentTarget;
    this.focusBtn.addEventListener('keydown', this.pullDown);
  }
  removePullDown() {
    this.focusBtn.removeEventListener('keydown', this.pullDown);
    this.focusBtn = null;
  }
  pullDown(e) {
    if (e.keyCode === 40) {
      this.show(e);
      this.doc.addEventListener('keydown', this.pullDownFocus);
      this.openedDialog.childNodes[0].focus();
    }
  }
  pullDownFocus(e) {
    if (e.keyCode === 38) {
      const previousElement = this.doc.activeElement.previousElementSibling;
      if (!previousElement) return;
      previousElement.focus();
    }
    if (e.keyCode === 40) {
      const nextElement = this.doc.activeElement.nextElementSibling;
      if (!nextElement) return;
      nextElement.focus();
    }
  }
  escape(e) {
    if (e.keyCode === 27) {
      this.hide();
    }
  }
}
export default PeriodSelectorSeparate;



// WEBPACK FOOTER //
// ./src/js/module/PeriodSelectorSeparate.js